import src from "IMAGE";
export default { src, width: 173, height: 88, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATElEQVR42i3LOwqAMBBF0Wet7sBWEFFRLHQD6dKmSpP9ryJ34A0c5i9JDRXZdXGOPkE/Vmz4cOBxjpkGLDjxehH9JMfo4e2D+L6wY+7hbAYcGTkDUQAAAABJRU5ErkJggg=="};
